import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
  Outlet,
} from "react-router-dom";
import ReactGA from "react-ga4";
import AOS from "aos";
import "aos/dist/aos.css";
import Home from "./pages/Home";
import Education from "./pages/solutions/Education";
import Corporate from "./pages/solutions/Corporate";
import AboutUs from "./pages/AboutUs";
import Connect from "./pages/Connect";
import EvokeSeries from "./pages/products/interactive-flat-panel/EvokeSeries";
import RiseSeries from "./pages/products/interactive-flat-panel/RiseSeries";
import InspireSeries from "./pages/products/interactive-flat-panel/InspireSeries";
import BlogDetails from "./pages/BlogDetails";
import Blogs from "./pages/Blogs";
import Thanks from "./pages/Thanks";
import Media from "./pages/Media";
import InteractiveFlatPanel from "./pages/blogs/InteractiveFlatPanel";
import LandingInteractiveFlatPanel from "./pages/landing-pages/InteractiveFlatPanel";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiesPolicy from "./pages/CookiesPolicy";
import Products from "./pages/products/Products";
import ProductDetails from "./pages/products/ProductDetails";
import ProductsCart from "./pages/products/ProductsCart";
import RefundReturnPolicy from "./pages/RefundReturnPolicy";
import EWastePolicy from "./pages/EWastePolicy";
import TermsOfUse from "./pages/TermsOfUse";
import AdminPage from "./pages/AdminPage";
import OrderHistory from "./pages/products/OrderHistory";
import OrderDetails from "./pages/products/OrderDetails";
import Inertia from "./pages/products/active-led/Inertia";
import Vista from "./pages/products/commercial-display/Vista";
import PaymentSuccess from "./pages/products/PaymentSuccess";
import PaymentFailure from "./pages/products/PaymentFailure";
import BookDemo from "./pages/BookDemo";
import GetQuote from "./pages/GetQuote";
import Downloads from "./pages/Downloads";
import UnsubscribePage from "./pages/Unsubscribe";
import { trackNavigation } from "./utils/trackNavigation";

// A component that tracks page view changes and logs current path
const PageTracker = () => {
  const location = useLocation();
  const userId = localStorage.getItem("userId") || "Guest";
  const sessionid = localStorage.getItem("sessionid") || "";

  useEffect(() => {
    const pageUrl = location.pathname + location.search;
    const trackingData = { userId, sessionid, pageUrl };

    trackNavigation(trackingData)
      .then((data) => {
        console.log("Navigation tracked successfully:", data);
      })
      .catch((error) => {
        console.error("Error tracking navigation:", error);
      });
  }, [location, userId, sessionid]);

  return null;
};

// Layout component that includes the PageTracker and renders children routes
const Layout = () => {
  const location = useLocation();
  return (
    <>
      {location.pathname !== "/admin" && <PageTracker />}
      <Outlet />
    </>
  );
};

const GAUrl = process.env.REACT_APP_ANALYTICS_ID;

const App = () => {
  useEffect(() => {
    // Initialize GA4 with your measurement ID
    ReactGA.initialize(GAUrl); // Replace with your actual GA4 measurement ID

    // Disable right-click
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Defining routes under the Layout component for shared page tracking
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/", element: <Home /> },
        { path: "/media", element: <Media /> },
        { path: "/shop", element: <Products /> },
        { path: "/products/cart", element: <ProductsCart /> },
        { path: "/payment-success", element: <PaymentSuccess /> },
        { path: "/payment-failure", element: <PaymentFailure /> },
        { path: "/products/orders", element: <OrderHistory /> },
        { path: "/products/order-details", element: <OrderDetails /> },
        { path: "/product-details/:slug", element: <ProductDetails /> },
        {
          path: "/products/interactive-flat-panel/evoke-series",
          element: <EvokeSeries />,
        },
        {
          path: "/products/interactive-flat-panel/rise-series",
          element: <RiseSeries />,
        },
        {
          path: "/products/interactive-flat-panel/inspire-series",
          element: <InspireSeries />,
        },
        { path: "/products/active-led/inertia-series", element: <Inertia /> },
        {
          path: "/products/commercial-display/vista-series",
          element: <Vista />,
        },
        { path: "/solutions/education", element: <Education /> },
        { path: "/solutions/corporate", element: <Corporate /> },
        { path: "/about-us", element: <AboutUs /> },
        { path: "/connect", element: <Connect /> },
        { path: "/thanks", element: <Thanks /> },
        { path: "/blogs", element: <Blogs /> },
        { path: "/blogs/:title", element: <BlogDetails /> },
        {
          path: "/blogs/interactive-flat-panel",
          element: <InteractiveFlatPanel />,
        },
        {
          path: "/coltec-smart-interactive-flat-panel-for-classroom",
          element: <LandingInteractiveFlatPanel />,
        },
        { path: "/privacy-policy", element: <PrivacyPolicy /> },
        { path: "/cookies-policy", element: <CookiesPolicy /> },
        { path: "/refund-return-policy", element: <RefundReturnPolicy /> },
        { path: "/e-waste-policy", element: <EWastePolicy /> },
        { path: "/terms-of-use", element: <TermsOfUse /> },
        { path: "/admin", element: <AdminPage /> },
        { path: "/book-a-demo", element: <BookDemo /> },
        { path: "/get-a-quote", element: <GetQuote /> },
        { path: "/download", element: <Downloads /> },
        { path: "/unsubscribe", element: <UnsubscribePage /> },
      ],
    },
  ]);

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
